// extracted by mini-css-extract-plugin
export var imgWrapper = "Project-module--img-wrapper--l5xTV";
export var img = "Project-module--img--jRPGx";
export var title = "Project-module--title--ctCmp";
export var project = "Project-module--project--hJhgb";
export var focusVisible = "Project-module--focus-visible--JBTP8";